import React from 'react';
import { Menu, Button, MenuItem } from '@mui/material';

const styles = {
  menuButton: {
    fontSize: 20,
    height: 20,
    paddingBottom: 14,
    borderRadius: 10,
  },
};

function RunActionMenu({
  isRun, matchingRun, isDynamic, onChange,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const EDIT_RUN = 'Edit Run';
  const COPY_RUN = 'Copy Run';
  const DELETE_RUN = 'Delete Run';
  const EDIT_RUN_SCHEDULE = 'Edit Run Schedule';
  const DELETE_RUN_SCHEDULE = 'Delete Run Schedule';

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (event) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        style={styles.menuButton}
        size="small"
        onClick={(event) => {
          event.stopPropagation();
          handleClick(event);
        }}
      >
        ...
      </Button>
      <Menu
        id="run-action-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={(event) => {
          handleClose(event);
        }}
      >
        <MenuItem
          onClick={(e) => {
            e.stopPropagation();
            onChange(e, matchingRun);
            setAnchorEl(null);
          }}
          name={isRun ? EDIT_RUN : EDIT_RUN_SCHEDULE}
          value={isRun ? EDIT_RUN : EDIT_RUN_SCHEDULE}
        >
          {isRun ? EDIT_RUN : EDIT_RUN_SCHEDULE}
        </MenuItem>
        {!isDynamic && isRun && (
          <MenuItem
            onClick={(e) => {
              e.stopPropagation();
              onChange(e, matchingRun);
              setAnchorEl(null);
            }}
            name={COPY_RUN}
            value={COPY_RUN}
          >
            {COPY_RUN}
          </MenuItem>
        )}
        <MenuItem
          onClick={(e) => {
            e.stopPropagation();
            onChange(e, matchingRun);
            setAnchorEl(null);
          }}
          name={isRun ? DELETE_RUN : DELETE_RUN_SCHEDULE}
          value={isRun ? DELETE_RUN : DELETE_RUN_SCHEDULE}
        >
          {isRun ? DELETE_RUN : DELETE_RUN_SCHEDULE}
        </MenuItem>
      </Menu>
    </>
  );
}

export default RunActionMenu;
